export default class StringUtil {
  /**
   * ランダムな文字列を生成します
   *
   * @param length
   * @returns {string}
   */
  static getRandomString(length = 8) {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
    const charsLength = chars.length
    let result = ''
    for (let i = 0; i < length; i++) {
      result += chars[Math.floor(Math.random() * charsLength)]
    }
    return result
  }
}
